import { ContentfulCallout } from '@jbhi-fi/apis/src/contentful/types';
import { CalloutProps } from '../../Callout/Callout';
import { AssetTransformer } from './AssetTransformer';
import { Props as AlertProps } from '@jbhi-fi/lanyard-ui/components/Alert/Alert';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import React from 'react';

export class CalloutTransformer {
  static toCalloutProps = (entry: ContentfulCallout): CalloutProps => {
    return {
      heading: entry.fields?.heading ?? '',
      body: entry.fields?.body,
      leftAnchorImage: entry.fields?.leftAnchorImage
        ? AssetTransformer.toContentfulImageProps(entry.fields?.leftAnchorImage)
        : undefined,
      secondaryImage: entry.fields?.secondaryImage
        ? AssetTransformer.toContentfulImageProps(entry.fields?.secondaryImage)
        : undefined,
    };
  };

  static toAlertProps = (entry: ContentfulCallout): AlertProps => {
    return {
      type: (entry.fields?.type.toLowerCase() ?? 'info') as AlertProps['type'],
      heading: entry.fields?.heading ?? '',
      children: entry.fields?.body ? <>{documentToReactComponents(entry.fields?.body)}</> : undefined,
      showIcon: true,
    };
  };
}
